import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()

export class InschrijvenService extends ResourceService {
  constructor(private authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.activity.listUrl, ServiceConfig.activity.detailUrl);
  }

  /**
   * subscribe to activity
   * @param id
   * @param subscription
   * @returns {Observable<R>}
   */
  subscribe(id, subscription) {
    return this.authorizedService.post(ServiceConfig.activity.subscribe.replace("{id}", id), subscription).map(data => {
      return data.json()
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/inschrijven.service.ts